import { DASH } from '@/app/shared/constants/common';
import { formatNumber, shortNumber } from '@/app/shared/lib/formatters';

export const formatVaultApy = (value?: string): string => {
  if (value == null || value === '') return DASH;
  const num = Number(value);
  if (Number.isNaN(num)) return DASH;
  return `${formatNumber(num * 100, 2, 2)}%`;
};

export const formatVaultShare = (value?: string): string => {
  if (value == null || value === '') return DASH;
  const num = Number(value);
  if (Number.isNaN(num)) return DASH;
  return `${formatNumber(num * 100, 0, 0)}% of vault`;
};

export const formatVaultPercent = (value?: string): string => {
  if (value == null || value === '') return DASH;
  const num = Number(value);
  if (Number.isNaN(num)) return DASH;
  return `${formatNumber(num * 100, 0, 0)}%`;
};

export const formatVaultTvl = (value?: string): string => {
  if (value == null || value === '') return DASH;
  const num = Number(value);
  if (Number.isNaN(num)) return DASH;
  if (Math.abs(num) >= 1_000_000) return `$${shortNumber(num)}`;
  return `$${formatNumber(num, 2, 2)}`;
};

export const formatApyLabel = (apy: string): string => (apy === DASH ? DASH : `${apy} APY`);

export const getTrancheTvl = (marketTvl?: string, share?: string): string => {
  const tvl = Number(marketTvl);
  const percentage = Number(share);
  if (!Number.isFinite(tvl) || !Number.isFinite(percentage)) return DASH;
  return formatVaultTvl(String(tvl * percentage));
};
